import styled from "styled-components";

const FilterSidebar = styled.div`
  background-color: rgb(245, 245, 245);
  flex: 0 0 210px;
  overflow: auto;
  padding: 0 25px 0 25px;
`;

export default FilterSidebar;



// WEBPACK FOOTER //
// ./src/components/layout/FilterSidebar.js